export const transferPatient = {
  selectClientOrgLocation: {
    heading: 'Select Client Organization and Location',
    organizationTitle: 'Client Organization',
    organizationPlaceholder: 'Select a Client Organization',
    locationTitle: 'Client Location',
    locationPlaceholder: 'Select a Client Organization'
  },
  selectAssignee: {
    heading: 'Select Assignee',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    role: 'Role',
    title: 'Title'
  },
  selectOrganization: {
    loadErrorMessage: 'Could not load pharmacy details',
    name: 'Name',
    createdOn: 'Created On',
    heading: 'Select RPM-Enabled Organization',
    noOrganizations: 'no organizations',
    currentlyAtDescription: (patientName: string, organizations: string) => `${patientName} is currently at ${organizations}`
  }
} as const;
